import { Component, HostListener, Input, OnChanges, Output } from '@angular/core';
import { ECElementEvent } from 'echarts';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-stacked-bar',
  templateUrl: './stacked-bar.component.html',
  styleUrls: ['./stacked-bar.component.css'],
})
export class StackedBarComponent implements OnChanges {
  @Input() graphData;
  @Input() xAxisLabel;
  @Input() graphAxisDetails;
  @Input() stackedBarChartTitle;
  @HostListener('window:resize', ['$event'])
  @Output() chartClick = new Subject<ECElementEvent>();
  onResize() {
    setTimeout(() => {
      this._plotBar();
      // this.chartOption?.resize();
    }, 1);
  }
  constructor() { }
  chartOption: any;

  ngOnChanges(): void {
    if (this.graphData?.length) {
      this._plotBar();
    }
  }

  /**
   * Determines whether chart click on
   * @param value
   */
  onChartClick(value: unknown) {
    this.chartClick.next(value as ECElementEvent);
  }


  _plotBar() {
    const series: echarts.BarSeriesOption[] = this.xAxisLabel.map(
      (name, i) => {
        return {
          name,
          type: 'bar',
          stack: 'total',
          barWidth: '30%',
          label: {
            show: true,
          },
          data: this.graphData?.[i]?.value?.counts?.map((data: any, index) => {
            return { value: data ?? 0, entityIds: this.graphData?.[i]?.value?.entities?.[index] ?? [], start: this.graphData?.[i]?.value?.start?.[index], end: this.graphData?.[i]?.value?.end?.[index] }
          }),
        };
      }
    );
    this.chartOption = {
      ...(this.stackedBarChartTitle && {
        title: {
          text: this.stackedBarChartTitle,
          top: 0,
          textStyle: {
            fontSize: 12,
            fontWeight: 'bold'
          },
        },
      }),
      legend: {
        selectedMode: true,
        top: 20
      },
      grid: {
        height: '60%',
      },
      tooltip: {
        trigger: 'axis',
        // axisPointer: { type: 'shadow' },
        formatter: (params) => {
          const [categoryInfo] = params;
          return `${categoryInfo?.axisValue}<br/>Start: ${categoryInfo?.data?.start ?? '--'}<br/>End: ${categoryInfo?.data?.end ?? '--'}`;
        }
      },
      yAxis: {
        type: 'value',
        name: this.graphAxisDetails?.yAxisDetails?.name,
        nameLocation: 'middle',
        nameTextStyle: {
          lineHeight: 30,
        },
      },
      xAxis: {
        type: 'category',
        data: this.graphAxisDetails?.xAxisDetails?.data,
        axisLabel: {
          fontSize: 7,
        },
        name: this.graphAxisDetails?.xAxisDetails?.name,
        nameLocation: 'middle',
        nameTextStyle: {
          lineHeight: 30,
        },
      },
      color: this.graphAxisDetails?.color,
      series,
    };
  }
}
